import { useRef, useState, useCallback, useEffect } from 'react';
import { canUseDOM, areOptionsEqual, arePluginsEqual } from 'embla-carousel-reactive-utils';
import EmblaCarousel from 'embla-carousel';

function useEmblaCarousel(options = {}, plugins = []) {
  const storedOptions = useRef(options);
  const storedPlugins = useRef(plugins);
  const [embla, setEmbla] = useState();
  const [viewport, setViewport] = useState();
  const reInit = useCallback(() => {
    if (embla) embla.reInit(storedOptions.current, storedPlugins.current);
  }, [embla]);
  useEffect(() => {
    if (canUseDOM() && viewport) {
      EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
      const newEmbla = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
      setEmbla(newEmbla);
      return () => newEmbla.destroy();
    } else {
      setEmbla(undefined);
    }
  }, [viewport, setEmbla]);
  useEffect(() => {
    if (areOptionsEqual(storedOptions.current, options)) return;
    storedOptions.current = options;
    reInit();
  }, [options, reInit]);
  useEffect(() => {
    if (arePluginsEqual(storedPlugins.current, plugins)) return;
    storedPlugins.current = plugins;
    reInit();
  }, [plugins, reInit]);
  return [setViewport, embla];
}
useEmblaCarousel.globalOptions = undefined;

export { useEmblaCarousel as default };
//# sourceMappingURL=embla-carousel-react.esm.js.map
